export enum DrinkingWaterAdditionalTypeEnum {
  FreshWater = 'fresh_water_module',
  WaterSoftener = 'water_softener',
}
